// Help from anywhere in the office app: the header's Help button opens the support chat in a
// dialog (the support agent explains how to do something; agents.askSupport, which every office
// role has through settings.view), so a CSR reaches it without the Agents place.

import { useEffect, useRef, useState } from 'react';
import { Chat } from '../agents/Chat.tsx';
import type { AgentsProps } from '../agents/props.ts';
import '../books/books.css';
import '../agents/agents.css';
import './help.css';

export function HelpDialog({
  held,
  timeZone,
  onClose,
}: {
  /** The permissions the person holds (agents.manage: the owner's controls). */
  held: readonly string[];
  timeZone?: string;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const [toast, setToast] = useState<string | null>(null);
  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) d.showModal();
  }, []);
  const props: AgentsProps = {
    isOwner: held.includes('agents.manage'),
    seesAgents: false,
    ...(timeZone ? { timeZone } : {}),
    toast: setToast,
    go: () => undefined,
    agentKey: 'support',
  };
  return (
    <dialog ref={ref} className="sheet help-dialog" aria-label="Help" onClose={onClose}>
      {/* Close sits with the title, as on every other sheet */}
      <form method="dialog" className="help-close">
        <button className="btn soft" type="submit">
          Close
        </button>
      </form>
      <div className="books agents">
        <Chat
          props={props}
          agentKey="support"
          title="Help"
          intro="Ask how to do something in Flowology. A change it suggests waits for the owner’s approval."
          examples={['How do I book a job?', 'Where do I set the trip charge?']}
        />
      </div>
      {toast && (
        <p className="error" role="status">
          {toast}
        </p>
      )}
    </dialog>
  );
}
